var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{ref:"rootElement",tag:"component",style:([
    // Before the children is render, we need to set the minHeight and minWidth
    // in order for the intersectionObserver to take into consideration the minimum size of the children
    !_setup.isVisible && {
      minHeight: `${_vm.minHeight}px`,
      minWidth: `${_vm.minWidth}px`,
    },
  ])},[(_setup.isVisible)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }